import { PRODUCT_IDS } from '@adsk/alloy-provider';

const getAvailableProductId = (productId) => {
  if (
    [
      PRODUCT_IDS.AUTOSPECS,
      PRODUCT_IDS.BUILD,
      PRODUCT_IDS.COST,
      PRODUCT_IDS.DOCS,
      PRODUCT_IDS.TAKEOFF,
    ].includes(productId)
  ) {
    return productId;
  }

  return PRODUCT_IDS.DOCS;
};

const getPackageDetailUrl = (projectId, productId, packageId) => {
  const availableProductId = getAvailableProductId(productId);
  return `/${availableProductId}/files/projects/${projectId}?moduleId=packages&packageId=${packageId}`;
};

export default getPackageDetailUrl;
